import React, { useEffect, useState } from 'react';
import PageLayout from './PageLayout';
import Monitor from './Monitor';
import { useCameras } from '../hooks';

const MonitorPage = () => {
  const cameras = useCameras();
  const [cameraId, setCameraId] = useState<string>();

  useEffect(() => {
    if (!cameras?.length) return;
    setCameraId(cameras[0].deviceId);
  }, [cameras]);

  return (
    <PageLayout>
      <Monitor
        showMonitor={true}
        cameraId={cameraId}
        onLicenseStatus={() => {}}
      />
    </PageLayout>
  );
};

export default MonitorPage;
